<template>
  <div
    v-if="isVisible"
    class="container padding-y-md"
  >
    <div role="alert" class="message success with-close with-icon display-flex flex-content-between flex-items-center">
      <font-awesome-icon
        :icon="$v7.duotone.faCommentQuestion"
        class="decorative"
      />
      <p class="margin-0"><strong>Help shape Font Awesome's future!</strong>
      (And maybe win a lifetime Pro subscription.)
      </p>
      <a
        href="https://fontawesome.typeform.com/survey2026"
        target="_blank"
        rel="noopener"
        class="button flat compact margin-bottom-0 margin-left-md"
      >
        Take the survey
        <font-awesome-icon
          :icon="$v7.solid.faArrowRight"
          class="margin-left-xs"
        />
      </a>
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="dismiss"
      >
        <font-awesome-icon
          :icon="$v7.duotone.faCircleXmark"
          style="--fa-width: auto"
        />
      </button>
    </div>
  </div>
</template>

<script>
  const STORAGE_KEY = 'survey-notice-2026-dismissed'

  export default {
    name: 'SurveyNotice',

    data() {
      return {
        dismissed: Boolean(localStorage.getItem(STORAGE_KEY))
      }
    },

    computed: {
      isVisible() {
        return !this.dismissed
      }
    },

    methods: {
      dismiss() {
        localStorage.setItem(STORAGE_KEY, '1')
        this.dismissed = true
      }
    }
  }
</script>
